"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isClassConstructor = void 0;
function isClassConstructor(obj) {
    return typeof obj === 'function' && obj.prototype && obj.prototype.constructor === obj;
}
exports.isClassConstructor = isClassConstructor;
